import api from '@api-client/client';
import { FC, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PipelineContext from './PipelineContext';

const PipelineProvider: FC<{ children: ReactNode; isMyPipeline?: boolean }> = ({
  children
}) => {
  const { id } = useParams();

  const { data: pipeline, isLoading: isPipelineLoading, refetch: refreshPipeline } = useQuery({
    queryKey: ['pipeline', id],
    queryFn: () => api.pipeline.get(Number(id)),
    enabled: !!id
  });

  const { data: pipelineStages, isLoading: isPipelineStagesLoading, refetch: refreshPipelineStages } = useQuery(
    {
      queryKey: ['pipelineStages', id],
      queryFn: () => api.pipeline.getPipelineStages(Number(id)),
      enabled: !!id
    }
  );

  return (
    <PipelineContext.Provider
      value={{
        pipeline,
        isPipelineLoading,
        pipelineStages,
        isPipelineStagesLoading,
        refreshPipeline,
        refreshPipelineStages
      }}
    >
      {children}
    </PipelineContext.Provider>
  );
};

export default PipelineProvider;
